import { axios } from "../axios";
import { BaseResponse, BaseResponseWithSingle, Status } from "../Shared";
import {
  AddOrRemoveObjectInteractionsRequest,
  CreateDiscussionMessageRequest,
  CreateDiscussionMessageResponse,
  CreateDiscussionThreadRequest,
  CreateDiscussionThreadResponse,
  CreateInteractionRequest,
  CreateInteractionResponse,
  DeleteDiscussionMessageRequest,
  DeleteDiscussionThreadRequest,
  DeleteInteractionRequest,
  UpdateDiscussionMessageRequest,
  UpdateDiscussionMessageResponse,
  UpdateDiscussionThreadRequest,
  UpdateDiscussionThreadResponse,
  UpdateInteractionRequest,
  UpdateInteractionResponse,
} from "./Types";

export const createDiscussionThread = async (
  req: CreateDiscussionThreadRequest
): Promise<BaseResponseWithSingle<CreateDiscussionThreadResponse>> => {
  return axios
    .request<BaseResponseWithSingle<CreateDiscussionThreadResponse>>({
      method: "post",
      url: "discussion/thread/create",
      data: req,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const createDiscussionMessage = async (
  req: CreateDiscussionMessageRequest
): Promise<BaseResponseWithSingle<CreateDiscussionMessageResponse>> => {
  return axios
    .request<BaseResponseWithSingle<CreateDiscussionMessageResponse>>({
      method: "post",
      url: "discussion/message/create",
      data: req,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const deleteDiscussionMessage = async (req: DeleteDiscussionMessageRequest): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "delete",
      url: "discussion/message/delete",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const deleteDiscussionThread = async (req: DeleteDiscussionThreadRequest): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "DELETE",
      url: "discussion/thread/delete",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const updateDiscussionMessage = async (
  req: UpdateDiscussionMessageRequest
): Promise<BaseResponseWithSingle<UpdateDiscussionMessageResponse>> => {
  return axios
    .request<BaseResponse>({
      method: "PATCH",
      url: "discussion/message/update",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const updateDiscussionThread = async (
  req: UpdateDiscussionThreadRequest
): Promise<BaseResponseWithSingle<UpdateDiscussionThreadResponse>> => {
  return axios
    .request<BaseResponse>({
      method: "PATCH",
      url: "discussion/thread/update",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const createInteraction = async (
  req: CreateInteractionRequest
): Promise<BaseResponseWithSingle<CreateInteractionResponse>> => {
  return axios
    .request<BaseResponseWithSingle<CreateInteractionResponse>>({
      method: "post",
      url: "interaction",
      data: req,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const updateInteraction = async (
  req: UpdateInteractionRequest
): Promise<BaseResponseWithSingle<UpdateInteractionResponse>> => {
  return axios
    .request<BaseResponseWithSingle<UpdateInteractionResponse>>({
      method: "patch",
      url: "interaction",
      data: req,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.data,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const deleteInteraction = async (req: DeleteInteractionRequest): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "delete",
      url: "interaction",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};

export const addOrRemoveObjectInteractions = async (
  req: AddOrRemoveObjectInteractionsRequest
): Promise<BaseResponse> => {
  return axios
    .request<BaseResponse>({
      method: "post",
      url: "interaction/objectInteractions",
      data: req,
    })
    .then(() => {
      return {
        status: Status.Success,
      };
    })
    .catch((error) => {
      return {
        status: Status.Error,
        errors: error.errors || [],
      };
    });
};
